import React from 'react'
import { Link } from 'react-router-dom'

const ProductCard=(props)=>{
  return (
    <div className="card">
      <Link to={`/categorias/${props.product}`}>
      <div className="card-sub">
        <div className="card-image">
          <img src={props.image} alt={props.name}/>
        </div>
        <div className="card-body">
          <p>{props.name}</p>
        </div>
      </div>
      <div className="price">
        <p>{`S/${props.price}`}</p>
      </div>
      </Link>
    </div>
  )
}

export default ProductCard
